import { useTranslation } from "react-i18next";
import InfoFlyUpModal from "../../../InfoFlyUpModal/index";
import InfoModal from "../../../InfoFlyUpModal/components/InfoModal";

export interface BloodPressureModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export default function BloodPressureModal({
  isOpen,
  onClose,
}: BloodPressureModalProps = {}) {
  const { t } = useTranslation();

  const modalProps = {
    title: t("HealthChart.bloodPressureModal.title"),
    description: t("HealthChart.bloodPressureModal.description"),
    importanceTitle: t("HealthChart.bloodPressureModal.importance.title"),
    textList: t("HealthChart.bloodPressureModal.list", {
      returnObjects: true,
    }),
  };

  if (isOpen !== undefined && onClose !== undefined) {
    return (
      <InfoModal
        isOpen={isOpen}
        handleClose={onClose}
        title={modalProps.title}
        description={modalProps.description}
        importanceTitle={modalProps.importanceTitle}
        textList={modalProps.textList}
      />
    );
  }

  return (
    <InfoFlyUpModal
      cardProps={{
        title: t("HealthChart.bloodPressureModal.card.title"),
        description: t("HealthChart.bloodPressureModal.card.description"),
      }}
      modalProps={modalProps}
    />
  );
}
